import { __rest } from "tslib";
import { createElement } from 'rax';
import classNames from 'classnames';
import Text from 'rax-text';
const Typography = (props) => {
    const { prefix = 'mt-', type = 'body-1', className, children, mark = false, underline = false, strong = false, code = false, delete: del, indented, color, style } = props, others = __rest(props, ["prefix", "type", "className", "children", "mark", "underline", "strong", "code", "delete", "indented", "color", "style"]);
    const clsPrefix = `${prefix}typography`;
    const newStyle = Object.assign({ color }, style);
    return (<Text {...others} className={classNames(`${clsPrefix}`, className, `${clsPrefix}--${type}`, {
            [`${clsPrefix}--mark`]: mark,
            [`${clsPrefix}--underline`]: underline,
            [`${clsPrefix}--strong`]: strong,
            [`${clsPrefix}--code`]: code,
            [`${clsPrefix}--delete`]: del,
            [`${clsPrefix}--${type}-indented`]: indented,
        })} style={newStyle}>
      {children}
    </Text>);
};
Typography.displayName = 'Typography';
export default Typography;
